<script lang="ts">
import { defineComponent, nextTick, PropType, ref } from 'vue';
import { ValidationRule } from 'quasar';
import IconCalendar from '@/shared/assets/icons/transaction/calendar.vue';

export default defineComponent({
  name: 'UiInputDate',
  components: { IconCalendar },
  props: {
    modelValue: {
      type: String as PropType<string | null>,
      default: '',
    },
    options: {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      type: [Array, Function] as PropType<readonly any[] | ((date: string) => boolean) | undefined>,
      default: () => [],
    },
    rules: {
      type: Array as PropType<ValidationRule[]>,
      default: () => [],
    },
    label: {
      type: String,
      default: '',
    },
    hint: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    lazyRules: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const popup = ref(false);
    const setDate = (date: string) => {
      emit('update:modelValue', date);
      nextTick(() => (popup.value = !date));
    };
    return {
      popup,
      setDate,
    };
  },
});
</script>

<template>
  <q-input
    :model-value="modelValue"
    :label="label"
    class="o-input"
    mask="##.##.####"
    inputmode="numeric"
    outlined
    :lazy-rules="lazyRules"
    no-error-icon
    hide-bottom-space
    :clearable="clearable"
    :disable="disable"
    :loading="loading"
    :rules="rules"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <template #append>
      <div class="flex justify-center items-center cursor-pointer ob-ml-xs" style="position: relative">
        <icon-calendar />
        <q-popup-proxy v-model="popup" cover transition-show="jump-down" transition-hide="jump-up">
          <q-date
            :model-value="modelValue"
            minimal
            color="primary"
            mask="DD.MM.YYYY"
            :disable="disable"
            :loading="loading"
            :options="options"
            @update:model-value="setDate"
          />
        </q-popup-proxy>
      </div>
    </template>
  </q-input>
</template>
